<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="col-lg-12">
    <b-row>
        <b-col style="text-align:center">
          <h3>Recursos / Plantillas</h3>
        </b-col>
    </b-row>
    <div class="card">
      <div class="tab-content">
        <div class="table-responsive">
          <div class="d-flex justify-content-between align-items-center mb-4 pl-4">
            <b-pagination class="p-0 m-0"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table">
            </b-pagination>
            <div class="d-flex align-items-center pl-3 mr-auto">
              <label class="p-0 m-0 pr-3 text-purple">Filtrar por tags</label>
              <vue-tags-input
                v-model="taglist"
                :autocomplete-items="tagslist"
                :add-only-from-autocomplete="true"
                @tags-changed="updatelist"
              />
            </div>
            <div class="col-md-3">
              <ResourceSearchs :routeApi="'templates'" ref="searchcomponent"
                :perPage = "perPage"
                :newTags2 = "newTags2"
                @update="onUpdateDataResource"
                @loading="onLoading"
              />
            </div>
            <b-button @click="onNew" variant="success">
              + Añadir
            </b-button>
          </div>
          <b-table hover :items="resources"
          :fields="fields"
          :per-page="0"
          :current-page="currentPage"
          >
            <template v-slot:cell(TIPO_PLANTILLA)="data">
              {{ data.item.TIPO_PLANTILLA === 'EF' ? 'E. Formula' : 'E. Simple' }}
            </template>
            <template v-slot:cell(PLANTILLA)="data">
              {{ data.item.PLANTILLA[languages.indexOf(languageGlobal)].TEXTO }}
            </template>
            <template v-slot:cell(actions)="row">
              <b-button class="btn btn-icon btn-icon-mini btn-round btn-info" @click="info(row.item, row.index, $event.target)">
                <i class="zmdi zmdi-edit"></i>
              </b-button>
              <b-button class="btn btn-icon btn-icon-mini btn-round btn-danger" @click="ondelete(row.item)">
                <i class="fa fa-trash"></i>
              </b-button>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
  <!-- Info modal -->
    <b-modal :id="infoModal.id" :title="infoModal.title" size="xl" hide-footer>
       <div class="modal-body">
         <ValidationObserver ref="formValidation">
              <div class="d-block">
                <div>
                  <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
                  Tipo Plantilla
                  <select class="form-control"
                    v-model="selectedItem.TIPO_PLANTILLA">
                    <option value="F">Fórmula</option>
                    <option value="ES">Enunciado simple</option>
                    <option value="EF">Enunciado de fórmula</option>
                  </select>
                    <span class="validation-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <br/>
                <div v-for="item in selectedItem.PLANTILLA" v-bind:key="item.LANGUAGE">
                  <label for="">Texto {{item.LANGUAGE}}</label>
                  <!-- required: item.LANGUAGE === 'ES' only during first phase of development. Otherwise required: true for all languages -->
                  <ValidationProvider :rules="{required: item.LANGUAGE === 'ES'}" v-slot="{ errors }">
                    <Editor v-model="item.TEXTO" :simpleProblem="true" :formulaProblem="false" :symbols="true" :formats="true">
                    </Editor>
                    <span class="validation-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <label for="Tag">
                <br>
                  Etiquetas</label>
                    <div>
                    <vue-tags-input
                      v-model="tag"
                      :tags="tags"
                      :autocomplete-items="autocompleteItems"
                      @tags-changed="update"
                    />
                  </div>
              </div>
              <div class="modal-footer">
                <button type="button" @click="save"
                class="btn btn-info btn-round waves-effect">
                  Guardar</button>
                <b-button class="btn btn-default btn-round waves-effect" block
                @click="$bvModal.hide('info-modal')">Cerrar</b-button>
            </div>
          </ValidationObserver>
        </div>
    </b-modal>
</div>

</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import Editor from '../../../components/utils/Editor.vue';
import ResourceSearchs from '../../../components/panel/ResourceSearchs.vue';
import searchMixin from '../../../mixins/search';

extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});

export default {
  components: {
    VueTagsInput,
    Editor,
    ResourceSearchs,
    ValidationProvider,
    ValidationObserver,
  },
  name: 'gridTemplates',
  mixins: [searchMixin],
  data() {
    return {
      perPage: 20,
      rows: 0,
      submitted: false,
      currentPage: 1,
      fields: [
        { key: 'TIPO_PLANTILLA', label: 'Tipo' },
        { key: 'PLANTILLA', label: 'Plantilla' },
        { key: 'actions', label: 'Acciones', tdClass: 'tdActionClass' },
      ],
      resources: [],
      selectedItem: {
        ID: null,
        TIPO_PLANTILLA: null,
        PLANTILLA: [],
      },
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      tag: '',
      taglist: '',
      tags: [],
      newTags: [],
      newTags2: [],
      tagslist: [],
      autocompleteItems: [],
    };
  },
  methods: {
    onNew() {
      this.limpiar();
      this.languages.forEach((language) => {
        this.selectedItem.PLANTILLA.push({
          LANGUAGE: language,
          TEXTO: null,
        });
      });
      this.infoModal.title = 'Nueva Plantilla';
      this.$root.$emit('bv::show::modal', this.infoModal.id);
    },
    limpiar() {
      this.selectedItem.ID = null;
      this.selectedItem.TIPO_PLANTILLA = null;
      this.selectedItem.PLANTILLA = [];
      this.tag = '';
      this.tags = [];
    },
    async ondelete(item) {
      const confirmation = await this.$bvModal.msgBoxConfirm('Esta a punto de eliminar un registro ¿Esta seguro?');
      if (confirmation) {
        /** Elimino los tags asociados */
        const url = `Tagstemplates/deleteTags/${item.ID}`;
        this.axios.get(url);

        this.loading = true;
        const response = await this.axios.post('templates/delete', { ID: item.ID });
        if (response.data.status === 'success') {
          this.loading = false;
          this.$toasted.show('Se elimino el registro seleccionado.', { theme: 'outline', type: 'success', duration: 5000 });
          this.getPostData();
        } else {
          this.loading = false;
          this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
        }
      }
    },
    info(item, index, button) {
      this.submitted = false;
      this.infoModal.title = 'Editar Plantilla';
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.selectedItem.ID = item.ID;
      this.selectedItem.PLANTILLA = item.PLANTILLA;
      this.selectedItem.TIPO_PLANTILLA = item.TIPO_PLANTILLA;
      this.getExistingTags(item.ID);
      this.$root.$emit('bv::show::modal', this.infoModal.id, button);
    },
    async save() {
      this.$refs.formValidation.validate().then(async (success) => {
        if (!success) {
          return;
        }
        this.loading = true;
        const templateData = {
          ID: this.selectedItem.ID || -1,
          TIPO_PLANTILLA: this.selectedItem.TIPO_PLANTILLA,
          PLANTILLA: this.selectedItem.PLANTILLA,
        };
        try {
          const response = await this.axios.post('templates/store', templateData);
          if (response.data.status === 'success') {
            // Solo si esta creando agrego el evento
            if (this.selectedItem.ID === -1 || this.selectedItem.ID === null) {
              const bc = new BroadcastChannel('new_resource_template');
              bc.postMessage(response.data.textDynamic);
            }

            const url = `Tagstemplates/deleteTags/${response.data.id}`;
            const url2 = 'Tagstemplates/saveTag';

            await this.axios.get(url);
            this.newTags.forEach(async (a) => {
              const resp = await this.axios.get(`Tags/findTagByName/${a.text}`, { name: a.text });
              if (resp.data.status === 'success') {
                await this.axios.post(url2, { id: resp.data.id, idtexto: response.data.id });
              } else {
                await this.axios.post(url2, { id: a.key, idtexto: response.data.id });
              }
            });

            this.$toasted.show('Los datos se guardaron satisfactoriamente.', { theme: 'outline', type: 'success', duration: 5000 });
            this.$root.$emit('bv::hide::modal', this.infoModal.id);
            this.limpiar();

            // Auto close if coming from a create event
            if (this.bAutoClose) {
              window.open('', '_self').close();
            }

            this.getPostData();
          } else {
            this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
          }
        } catch (e) {
          this.$toasted.show('Error al procesar la plantilla', { theme: 'outline', type: 'error', duration: 5000 });
          this.loading = false;
        }
      });
    },
    async getTemplates() {
      this.loading = true;

      try {
        const response = await this.axios.get('templates');
        this.resources = response.data;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    async getPostData() {
      this.loading = true;
      try {
        const response = await this.axios.get('templates', {
          params: {
            currentPage: this.currentPage,
            size: this.perPage,
            newTags: this.newTags2,
            resourcetosearch: this.$refs.searchcomponent.resoursetosearch,
          },
        });
        this.rows = response.data.rows;
        this.resources = Object.keys(response.data.results).map(k => response.data.results[k]);
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    initItems() {
      const url = 'Tags';
      const datos = [];

      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ text: a.NOMBRE, key: a.ID });
        });
        this.autocompleteItems = datos;
      })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    },
    update(newTags) {
      this.tags = newTags;
      this.newTags = newTags;
    },
    listTags() {
      const url = 'Tags';
      const datos = [];
      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ key: a.ID, text: a.NOMBRE });
        });
        this.tagslist = datos;
      })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    },
    updatelist(newTags) {
      this.newTags2 = newTags;
      this.getPostData();
    },
    async getExistingTags(idtxt) {
      const url = `Tagstemplates/findByTemplate/${idtxt}`;
      const datos = [];
      this.loading = true;

      try {
        this.axios.get(url).then((res) => {
          res.data.forEach((a) => {
            datos.push({ text: a.NOMBRE, key: a.ID });
          });
          this.tags = datos;
        })
          .catch((error) => {
            console.error(error);
          });
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
  },
  async mounted() {
    await this.getPostData();
    this.initItems();
    this.listTags();

    // Open create modal automatically
    const self = this;
    const bc = new BroadcastChannel('new_resource_template_open');
    bc.onmessage = () => {
      self.bAutoClose = true;
      self.onNew();
    };

    if (this.$route.params.id != null) {
      this.loading = true;
      const response = await this.axios.get('templates/gettemplate', {
        params: {
          id: this.$route.params.id,
        },
      });
      const item = response.data;
      this.loading = false;
      this.info(item, null, null);
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.getPostData().catch((error) => {
          console.error(error);
        });
      },
    },
  },
};
</script>
<style>
  .tdActionClass{
    width: 180px;
    text-align: center
  }
  .red {
    color: red;
  }
</style>
